import Vue from 'vue'

import Filters from "@/plugins/filters";
import Mixins from "@/plugins/mixins";
import VueMatchHeights from 'vue-match-heights';

Vue.use(VueMatchHeights, {
    disabled: [767]
});

Vue.use(Filters);
Vue.use(Mixins);